import React from 'react';
import { partial } from 'lodash';
import { SwitchItem } from '../../Forms/SwitchItem';
import { getTranslationKey } from '../../../modules/utils';
import { IShopSalesAutomation } from '../../../modules/types';
import { SWITCH_DIRECTION, FORM_MARGIN, SUPPORT_LINKS } from './constants';

interface IProps {
  abandonedShoppingCartReminder: IShopSalesAutomation['abandonedShoppingCartReminder'];
  updateFormValue: (path: string, value: unknown) => void;
}

export const AbandonedShoppingCartSection = React.memo(
  ({ abandonedShoppingCartReminder, updateFormValue }: IProps) => (
    <SwitchItem
      value={abandonedShoppingCartReminder?.enabled}
      changeCallback={partial(updateFormValue, 'abandonedShoppingCartReminder.enabled')}
      label={getTranslationKey('collectionShop.abandonedShoppingLabel')}
      direction={SWITCH_DIRECTION}
      margin={FORM_MARGIN}
      id="abandonedShoppingCartReminder-switch"
      withTooltip
      tooltipText={getTranslationKey('learnMoreLink', {
        link: SUPPORT_LINKS.abandonedCart,
        text_link: SUPPORT_LINKS.abandonedCart
      })}
      isIconTooltip
    />
  )
);
